<div class="right-side p-5">
  <h2>Customize Feedback</h2>
  <div class="section">
    <form [formGroup]="form">
      <div formArrayName="questionArray">
        <div class="section" *ngFor="let question of questionArray.controls; let i = index" [formGroupName]="i">

          <!-- Hidden Input Field -->
          <input type="hidden" formControlName="uniqueId">

          <div class="row">

            <!-- Question Section-->
            <div class="col-md-4">
              <mat-form-field appearance="outline">
                <mat-label>Question Section</mat-label>
                <input matInput formControlName="section" placeholder="Question section" />
                <mat-error *ngIf="question.get('section')?.hasError('required') && question.get('section')?.touched">
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Question Field -->
            <div class="col-md-4">
              <mat-form-field appearance="outline">
                <mat-label>Question</mat-label>
                <textarea matInput placeholder="Enter your question" formControlName="questionText"></textarea>
                <mat-error *ngIf="question.get('questionText')?.hasError('required') && question.get('questionText')?.touched">
                  Question is required.
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Answer Type Dropdown -->
            <div class="col-md-4">
              <mat-form-field appearance="outline">
                <mat-label>Answer Type</mat-label>
                <mat-select formControlName="answerType">
                  <mat-option value="Radio">Radio</mat-option>
                  <mat-option value="Text">Text</mat-option>
                </mat-select>
                <mat-error *ngIf="question.get('answerType')?.hasError('required') && question.get('answerType')?.touched">
                  Answer type is required.
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Answer Options *ngIf="question.get('answerType')?.value !== 'Text'" -->
          <div formArrayName="answerOptions">
            <div *ngFor="let option of getAnswerOptions(i).controls; let j = index" [formGroupName]="j" class="row">
              <!-- Option Text -->
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Option Text</mat-label>
                  <input matInput formControlName="optionText" />
                  <mat-error *ngIf="option.get('optionText')?.hasError('required') && option.get('optionText')?.touched">
                    Option text is required.
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Answer Rating -->
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Answer Rating</mat-label>
                  <mat-select formControlName="answerRating">
                    <mat-option *ngFor="let rating of [0,1,2,3,4,5]" [value]="rating">{{ rating }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="option.get('answerRating')?.hasError('required') && option.get('answerRating')?.touched">
                    Rating is required.
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Remove Answer Option -->
              <div class="col-md-4">
                <button class="btn btn-primary btn-sm me-2 mt-4" type="button" (click)="addAnswerOption(i)"><i class="bi bi-plus-lg"></i> Add Option</button>
                <button class="btn btn-danger me-2 btn-sm mt-4" type="button" (click)="removeAnswerOption(i, j)" [disabled]="getAnswerOptions(i).length <= 1"><i class="bi bi-trash"></i> Remove Option</button>
              </div>

            </div>

          </div>

          <!-- Remove Question Button -->
          <button class="btn btn-danger btn-sm me-2 mt-2" type="button" (click)="removeQuestion(i)" [disabled]="questionArray.length === 1"><i class="bi bi-trash"></i> Remove Question</button>
        </div>
      </div>

      <!-- Add New Question Button -->
      <button class="btn btn-primary me-2 mt-2 btn-sm" type="button" (click)="addQuestion()"><i class="bi bi-plus-lg"></i> Add More Question</button>

      <!-- Submit Button -->
      <button class="btn btn-success me-2 btn-sm mt-2" type="submit" (click)="onSubmit()" [disabled]="form.invalid">Submit</button>


      <hr />

      <!-- Search Section -->
      <div class="search">
        <div class="row">
          <div class="col-md-8"></div>
          <div class="col-md-3">
            <input matInput class="form-control" formControlName="search" placeholder="Search" />
          </div>
          <div class="col-md-1">
            <button type="button" class="btn btn-primary" (click)="onSearch()">Search</button>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <!-- Data Table -->
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Section</th>
              <th>Question Text</th>
              <th>Answer Type</th>
              <th>Option Text</th>
              <th>Is Active</th>
              <th>Created Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of dataSource; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ item.section }}</td>
              <td>{{ item.questionText }}</td>
              <td>{{ item.answerType }}</td>
              <td>{{ item.optionText || 'N/A' }}</td>
              <td>{{ item.isActive }}</td>
              <td>{{ item.createdDate }}</td>
              <td>
                <button class="btn btn-primary btn-sm me-2 mt-1" (click)="onAction(item.uniqueId, 'select')" [disabled]="disabledRows.has(item.uniqueId)"><i class="bi bi-pencil"></i> Edit</button>
                <button type="button" class="btn btn-sm mt-1"
                        [ngClass]="{'btn-success': item.isActive === 'DeActive', 'btn-danger': item.isActive === 'Active'}"
                        (click)="onAction(item.uniqueId, item.isActive)">
                  {{ item.isActive === 'Active' ? 'Deactivate' : 'Activate' }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <mat-paginator [length]="length"
                     [pageSize]="pageSize"
                     [pageIndex]="pageIndex"
                     [pageSizeOptions]="pageSizeOptions"
                     showFirstLastButtons
                     (page)="onPageChange($event)">
      </mat-paginator>

    </form>

  </div>
</div>
